import { createContext, ReactNode, useContext, useMemo } from "react";

const HighlightTermsContext = createContext<string[]>([]);

const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function HighlightTermsProvider({
  query,
  children,
}: {
  query: string;
  children: ReactNode;
}) {
  const terms = useMemo(
    () => Array.from(new Set(query.toLowerCase().split(/\s+/).filter(Boolean))),
    [query],
  );
  return (
    <HighlightTermsContext.Provider value={terms}>
      {children}
    </HighlightTermsContext.Provider>
  );
}

export function Highlight({ text }: { text: string | null | undefined }) {
  const terms = useContext(HighlightTermsContext);

  if (!text || !terms.length) {
    return <>{text}</>;
  }

  // Longest first, so "smith" wins over "s" when both match the same spot.
  const pattern = new RegExp(
    `(${[...terms]
      .sort((a, b) => b.length - a.length)
      .map(escapeRegExp)
      .join("|")})`,
    "gi",
  );

  return (
    <>
      {text.split(pattern).map((part, index) =>
        index % 2 === 1 ? (
          <mark key={index} className="rounded-sm bg-brand-lime text-inherit">
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
}
